/**
 * Surveyor Chat Room — wraps the shared ChatRoom for surveyor context.
 */
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { ChatRoom } from '../shared/ChatRoom';
import { useChatStore } from '../../store/chatStore';

export const SurveyorChatRoom: React.FC = () => {
  const { conversationId } = useParams<{ conversationId: string }>();
  const {
    activeConversation,
    conversationMessages,
    conversationMessagesLoading,
    loadConversation,
    loadConversationMessages,
    sendConversationMessage,
    clearConversation,
  } = useChatStore();

  useEffect(() => {
    if (!conversationId) return;
    loadConversation(conversationId);
    loadConversationMessages(conversationId);
    return () => clearConversation();
  }, [conversationId, loadConversation, loadConversationMessages, clearConversation]);

  const refresh = () => {
    if (!conversationId) return;
    loadConversation(conversationId);
    loadConversationMessages(conversationId);
  };

  const handleSend = (content: string, replyToId?: string) => {
    if (!conversationId) return;
    sendConversationMessage(conversationId, content, replyToId);
  };

  if (conversationMessagesLoading && conversationMessages.length === 0) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: '#636E72' }}>
        Loading chat...
      </div>
    );
  }

  return (
    <ChatRoom
      conversation={activeConversation}
      messages={conversationMessages}
      onSend={handleSend}
      onRefresh={refresh}
    />
  );
};
